import React from "react";
import BoxFavorite from "components/Box/BoxFavorite";
import styles from "./Favorites.module.scss";
import { favBox } from "assets/images";

class Favorites extends React.Component {
    state = {
        open: false
    };

    favoritar = selectedMkr => {
        this.props.favoritar(selectedMkr);
    };

    render() {
        const {
            estabelecimentosFavoritos,
            userLocation,
            setSelectedEstabelecimento
        } = this.props;
        return estabelecimentosFavoritos &&
            estabelecimentosFavoritos.length > 0 ? (
            estabelecimentosFavoritos.map(favorite => (
                <BoxFavorite
                    item={favorite}
                    isFavorite={true}
                    favoritar={() => this.favoritar(favorite)}
                    userLocation={userLocation}
                    setSelectedEstabelecimento={setSelectedEstabelecimento}
                    estabelecimentosFavoritos={
                        this.props.estabelecimentosFavoritos
                    }
                    selectedMkr={this.props.selectedMkr}
                />
            ))
        ) : (
            <div className={styles.favoriteBox}>
                <img src={favBox} className={styles.favBox} alt="Favoritos"/>
                <p>Você ainda não tem favoritos</p>
            </div>
        );
    }
}

export default Favorites;
